import { createVNode as l, mergeProps as i } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MailFilledStandard.js";
import d from "../components/PfIcon.js";
const r = (t, a) => {
  const e = {
    ...t,
    ...a.attrs
  };
  return l(d, i(e, {
    icon: o
  }), null);
};
r.displayName = "MailFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
